module.exports = __webpack_public_path__ + "img/Citibank.d16a1ba0.svg";